<template>
	<div v-if="status.offline && status.unsaved" role="alert" class="fixed bottom-0 inset-x-0 z-50 bg-ihh-dark-salmon text-ihh-midnight-gray px-4 py-3 text-center text-sm font-ihh-bold print:hidden">
		{{ text }}
	</div>
</template>

<script>
import { cartSyncStatus } from '../../helpers/cart.js'
import { OFFLINE_BANNER_TEXT } from '../../helpers/cartOffline.js'

export default {
	name: 'CartOfflineBanner',
	computed: {
		status() {
			return cartSyncStatus.value
		},
		text() {
			return OFFLINE_BANNER_TEXT
		},
	},
}
</script>
